const cache = new WeakMap();

export function requestSteamMarketLayout(games, width, height, colorScale, shape) {
  const entries = cache.get(games) || [];
  const cached = entries.find(entry => entry.width === width && entry.height === height &&
    entry.colorScale === colorScale && entry.shape === shape);
  if (cached) return { promise: Promise.resolve(cached.nodes), cancel() {} };

  const worker = createSteamMarketWorker();
  const promise = new Promise((resolve, reject) => {
    worker.onmessage = ({ data }) => {
      worker.terminate();
      if (data.error) { reject(new Error(data.error)); return; }
      const byId = new Map(games.map(game => [game.app_id, game]));
      const nodes = data.nodes.map(node => ({ ...node, data: { ...byId.get(node.data.app_id), color: node.data.color } }));
      const saved = cache.get(games) || [];
      saved.push({ width, height, colorScale, shape, nodes });
      if (saved.length > 4) saved.shift();
      cache.set(games, saved);
      resolve(nodes);
    };
    worker.onerror = event => {
      worker.terminate();
      reject(new Error(event.message || "Steam Market Mind layout worker failed."));
    };
    worker.onmessageerror = () => {
      worker.terminate();
      reject(new Error("Steam Market Mind layout could not be received."));
    };
    try {
      worker.postMessage({
        games: games.map(({ app_id, name, ccu }) => ({ app_id, name, ccu, color: colorScale(ccu) })),
        width, height, shape,
      });
    } catch (error) {
      worker.terminate();
      reject(error);
    }
  });
  return { promise, cancel: () => worker.terminate() };
}
import { createSteamMarketWorker } from "./createSteamMarketWorker";
